/*
 * @fileOverView NewsCarousel component definition
 */

import Vue from 'vue';
import 'slick-carousel';

/**
 * A reference to the selectors used in this view
 *
 * @property SELECTORS
 * @type {Object}
 * @private
 */
const SELECTORS = {
  'ARROW_NEXT': '.js-carouselNavigation-arrow_next',
  'ARROW_PREV': '.js-carouselNavigation-arrow_prev',
  'COUNT_CURRENT': '.js-carouselNavigation-count-current',
  'COUNT_TOTAL': '.js-carouselNavigation-count-total'
};

/**
 * A reference to the carousel options used in this view
 *
 * @property CAROUSEL_OPTIONS
 * @type {Object}
 * @private
 */
const CAROUSEL_OPTIONS = {
  infinite: false,
  mobileFirst: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1.5
      }
    },
    {
      breakpoint: 920,
      settings: {
        slidesToShow: 2.25
      }
    },
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 3.25
      }
    }
  ],
  speed: 500
};

/**
 * [NewsCarousel Vue]
 * @type {class}
 */
Vue.component('news-carousel-vue', {
  mounted() {
    const $items = $(this.$refs.items);

    const itemCarousel = $items.slick({...CAROUSEL_OPTIONS,
      nextArrow: $(this.$el).find(SELECTORS.ARROW_NEXT),
      prevArrow: $(this.$el).find(SELECTORS.ARROW_PREV)
    });

    // Handling the counter (CURRENT/TOTAL).
    $(this.$el).find(SELECTORS.COUNT_CURRENT).text(itemCarousel[0].slick.currentSlide + 1);
    $(this.$el).find(SELECTORS.COUNT_TOTAL).text(itemCarousel[0].slick.slideCount);

    $items.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $(this.$el).find(SELECTORS.COUNT_CURRENT).text(nextSlide + 1);
    });
  }
})
